import React from "react";
import "../styles/ChecklistCard.css";
import Clause from "./Clause";

export default function YTClauseCard({
  ClauseDataCommon,
  ClauseDataSituational,
  ClauseCardDescription,
}) {
  return (
    <div className="checklist-card ">
      <div className="flex flex-wrap checklist-card-header mb-5">
        <div>Common Conditions/Clauses</div>
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: ClauseCardDescription[0].text,
        }}
      />

      <br />
      {ClauseDataCommon.length === 0 ? (
        ""
      ) : (
        <h2 className="pl-2 pb-2">Conditions in the Contract</h2>
      )}

      <ul>
        {ClauseDataCommon.map((item, index) => (
          <div key={index} className="pl-3 pb-1">
            <Clause Clause={item} />
          </div>
        ))}
      </ul>
      <br />
      {ClauseDataSituational.length === 0 ? (
        ""
      ) : (
        <h2 className="pl-2 pb-2">Common Situational Terms & Conditions</h2>
      )}

      <ul>
        <ul>
          {ClauseDataSituational.map((item, index) => (
            <div key={index} className="pl-2">
              <Clause Clause={item} />
            </div>
          ))}
        </ul>
      </ul>
      <br />
    </div>
  );
}
